import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Company,
  CompanyDetail,
  CompanyInstallationsDetail,
  CompanyPersonsDetail,
} from 'src/app/model/company/company';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the 'Company' json data
   * @returns an Observable
   */
  public getCompanies(): Observable<Company[]> {
    //return this.authGetObs<Companies>( COMPANY_URL );
    let url = 'http://localhost:9090/clients';
    return this.http.get<Company[]>(url);
  }

  /**
   * Get the 'CompanyDetail' json data
   * @returns an Observable
   */
  public getCompany(id: string): Observable<CompanyDetail> {
    return this.authGetObs<CompanyDetail>(this.getCompanyUrl(id));
  }

  /**
   * Get the 'CompanyPersonsDetail' json data
   * @returns an Observable
   */
  public getCompanyPersonsDetailData(
    id: string
  ): Observable<CompanyPersonsDetail> {
    return this.authGetObs<CompanyPersonsDetail>(this.getCompanyPersons(id));
  }

  /**
   * Get the 'CompanyInstallationsDetail' json data
   * @returns an Observable
   */
  public getCompanyInstallationsDetailData(
    id: string
  ): Observable<CompanyInstallationsDetail> {
    return this.authGetObs<CompanyInstallationsDetail>(
      this.getCompanyInstallationsUrl(id)
    );
  }
}
